// extracted by mini-css-extract-plugin
export default {"header-background":"MsgModal_header-background__A6LBd","modal-button":"MsgModal_modal-button__I9NBc","modal-button-no":"MsgModal_modal-button-no__e3DXD"};